export default __webpack_public_path__ + "3975e6fad22ea68c19c7e899d91d2185.png";